import { optionsToStrategy } from '@/common/utils/optionsToStrategy'
import { BillingBillSupplyAuthorizationStatus } from '@/features/billingBills/types/billingBillSupplyAuthorization.type'

export const billingSupplyAuthorizationStatus: Record<BillingBillSupplyAuthorizationStatus, string> = {
  pending: 'Pendente',
  approved: 'Aprovada',
  rejected: 'Rejeitada',
}

export const billingSupplyAuthorizationStatusOptions = Object.entries(billingSupplyAuthorizationStatus).map(
  ([value, label]) => ({ value, label }),
)

export const billingSupplyAuthorizationStatusStrategy = optionsToStrategy(billingSupplyAuthorizationStatusOptions)
